export const STEP_INIT = 'STEP_INIT';
export const STEP_START = 'STEP_START';
export const STEP_CREATEORDER = 'STEP_CREATEORDER';
export const STEP_GETWEBPAYGUI = 'STEP_GETWEBPAYGUI';
export const STEP_WEBPAYPROCEED = 'STEP_WEBPAYPROCEED';
export const STEP_VALIDATE = 'STEP_VALIDATE';
export const STEP_DONE = 'STEP_DONE';
export const STEP_ERROR = 'STEP_ERROR';